export * from './imageTextBlock.variants.defaults';
